import React, { useCallback, useEffect, useState } from 'react'
import { CrearGrupoActividadHoraExtra, ObtenerInformacionGeneralGrupoActividades } from '../FunctionsParametrosHE'
import { InformacionGeneralGruposActividades, PostGrupoActividadesHorasExtras } from '../TypesParametrosHorasExtras'
import { showAlert } from '../Actividades/ActividadesHorasExtras'
import Cargando from 'components/Varios/Cargando'

import { Row, Col, Button, Input } from "reactstrap"
import TableGruposActividadesHorasExtras from './TableGruposActividadesHorasExtras'
import { useParametrosHorasExtrasContext } from 'Context/ParametrosHorasExtrasContext'


export default function GruposActividadesHorasExtras() {

    const [loading, setloading] = useState<boolean>(false)
    const [creando, setcreando] = useState<boolean>(false)

    const [textoGrupo, settextoGrupo] = useState<string>("")


    const [informacioGrupoActividadesHE, setinformacioGrupoActividadesHE] = useState<InformacionGeneralGruposActividades | undefined>(undefined)

    const {
        recargarInformacionGeneralGrupos,
        setrecargarGruposActivos,
        setrecargarInformacionGeneralGrupos


    } = useParametrosHorasExtrasContext()

    function VaciarCampos() {
        settextoGrupo("")


    }

    const ObtenerInformacionGeneral = useCallback(
        async () => {
            setloading(true)

            const respuesta = await ObtenerInformacionGeneralGrupoActividades();

            if (respuesta.status === 200 && respuesta.dataResponse && respuesta.dataResponse) {
                setinformacioGrupoActividadesHE(respuesta.dataResponse);
                if(!recargarInformacionGeneralGrupos){
                    setrecargarGruposActivos(true)
                }
                
                setrecargarInformacionGeneralGrupos(false)
            }
            else if(respuesta.status === 401){
                showAlert("Su usuario no se encuentra autorizado para verificar la información", false)
            }
            else {
                const mensajeError = "No ha sido posible obtener información de Grupos de Actividades";
                showAlert(respuesta.errorMessage ?? mensajeError, false)
            }

            setloading(false)
        },
        [recargarInformacionGeneralGrupos],
    )


    // async function ObtenerInformacionGeneral() {
    //     setloading(true)

    //     const respuesta = await ObtenerInformacionGeneralGrupoActividades();

    //     if (respuesta.status === 200 && respuesta.dataResponse && respuesta.dataResponse) {
    //         setinformacioGrupoActividadesHE(respuesta.dataResponse);
    //         setrecargarGruposActivos(true)
    //         setrecargarInformacionGeneralGrupos(false)
    //     }
    //     else {
    //         const mensajeError = "No ha sido posible obtener información de Grupos de Actividades";
    //         showAlert(respuesta.errorMessage ?? mensajeError, false)
    //     }

    //     setloading(false)
    // }

    async function CrearGrupoActividad(newOption: string) {
        setcreando(true)

        const nuevoGrupo: PostGrupoActividadesHorasExtras = {
            grupo: newOption
        }

        const respuesta = await CrearGrupoActividadHoraExtra(nuevoGrupo)

        if (respuesta.status === 200) {
            showAlert("Se ha creado el grupo con éxito", true);
            VaciarCampos()
            await ObtenerInformacionGeneral();
        }
        else if(respuesta.status === 401){
            showAlert("Su usuario no se encuentra autorizado para realizar la acción", false)
        }
        else {
            const mensajeDefault = "Ha ocurrido un inconveniente al tratar de crear el grupo"
            showAlert(respuesta.errorMessage ?? mensajeDefault, false);
        }




        setcreando(false)
    }


    useEffect(() => {
        ObtenerInformacionGeneral()
    }, [])

    useEffect(() => {
        if (recargarInformacionGeneralGrupos) {
            ObtenerInformacionGeneral()
        }
    }, [recargarInformacionGeneralGrupos])


    return (
        <React.Fragment>
            {loading && <Cargando />}
            {!loading && (
                <Row className="row-no-margin">
                    <Col xl={12}>
                        <Row>
                            <Col xl={5}>
                                <Row>
                                    <Col xl={12}>
                                        <span className={"labelParametrosHE"}> Grupo</span>
                                    </Col>
                                    <Col xl={12}>
                                        <Input type="text" value={textoGrupo} onChange={(e) => {
                                            var texto = e.target.value;
                                            if (texto) {
                                                texto = texto.toUpperCase()
                                            }
                                            settextoGrupo(texto)
                                        }

                                        }>
                                        </Input>
                                    </Col>

                                </Row>
                            </Col>
                            <Col xl={2} className={"d-flex justify-content-start"}>
                                <Button
                                    className={"buttonAgregarActividades"}
                                    disabled={textoGrupo === ""}
                                    onClick={() => CrearGrupoActividad(
                                        textoGrupo
                                    )}
                                >
                                    Agregar
                                </Button>
                            </Col>
                        </Row>

                    </Col>
                    <Col xl={12}>
                        {
                            informacioGrupoActividadesHE !== undefined && informacioGrupoActividadesHE.listadoGrupoActividades.length > 0 &&
                            (
                                <TableGruposActividadesHorasExtras
                                    gruposActividadesHorasExtras={informacioGrupoActividadesHE.listadoGrupoActividades}
                                    opcionesEstado={informacioGrupoActividadesHE.opcionesEstadoActividad}
                                    cargarGrupos={() => ObtenerInformacionGeneral()}
                                />

                            )

                        }

                    </Col>
                </Row>
            )}
        </React.Fragment>
    )
}
